import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "@/config/authConfig";
import styles from "../Login/styles.module.css";

export const SignedOut = () => {
  const { instance } = useMsal();

  const handleSignIn = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginWrapper}>
        <h1>Signed out</h1>
        <p>You have been signed out. You may close this tab.</p>
        <button onClick={handleSignIn}>Sign in again</button>
      </div>
    </div>
  );
};
